import React, {useContext} from 'react'
import {
    Typography,
    FormControlLabel,
    Radio,
    FormControl,
    FormHelperText,
    FormLabel,
    Stack,
    TextField,
} from '@mui/material'
import {Trans} from 'react-i18next'
import productTypeIsOneOf from '../../../lib/productTypeIsOneOf'
import {
    ComplaintState,
    ComplaintTypeState,
    ProductTypeOptions,
    YesNoOptions,
} from '../../../contexts/types'
import {OrgCustomizationContext} from "../../../themes/OrgCustomizationProvider";

type EstheticOptionsProps = {
    productType: ProductTypeOptions
    selectedOption: string
    handleTextFieldChange: (
        fieldName: keyof ComplaintTypeState,
        value: string
    ) => void
    estheticExplanation: string
    estheticExplanationError: string
    complaint: ComplaintState
}

const EstheticOptions: React.FC<EstheticOptionsProps> = ({
                                                             productType,
                                                             selectedOption,
                                                             handleTextFieldChange,
                                                             estheticExplanation,
                                                             estheticExplanationError,
                                                             complaint,
                                                         }) => {
    const eventOccurrence = complaint.complaintType.location
    const wasPatientInvolved = complaint.generalComplaint
        .wasPatientInvolved as YesNoOptions
    const {t, tns} = useContext(OrgCustomizationContext)

    if (complaint.generalComplaint.wasPatientInvolved === 'YES' && complaint.generalComplaint.wasProductPlaced === 'NO') return null;

    const handleChange = (
        e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
    ) => {
        handleTextFieldChange('estheticExplanation', e.target.value)
    }

    return (
        <>
            {/* Esthetic */}
            <Stack spacing={0}>
                <Typography
                    variant='body1'
                    color='secondary.contrastText'
                    sx={{pt: 2}}
                >
                    <Trans i18nKey={tns('cti_complaint_esthetic')}>
                        -
                        <Typography
                            component='span'
                            sx={{color: 'primary.main'}}
                        >
                            -
                        </Typography>
                        -
                    </Trans>
                </Typography>

                {productTypeIsOneOf(['ABUTMENT'], productType) && (
                    <FormControlLabel
                        value='COLOR_MISMATCHING'
                        control={<Radio/>}
                        label={t('cti_option_color_mismatching') as string}
                    />
                )}

                {/* 
                    The Event Occurrence can only be 4 or 5 if the Patient Was Involved.
                    Event Occurrence logic is being shown here for explicitness and code readability.
                 */}

                {wasPatientInvolved === 'YES' &&
                    (eventOccurrence === '4_CLINIC_DURING_PROCEDURE' ||
                        eventOccurrence === '5_CLINIC_AFTER_PROCEDURE') && (
                        <FormControlLabel
                            value='SHINES_THROUGH'
                            control={<Radio/>}
                            label={t('cti_option_shines_through', {productType: t(`pt_option_${productType.toLowerCase()}`)})}
                        />
                    )}

                {wasPatientInvolved === 'YES' &&
                    (eventOccurrence === '4_CLINIC_DURING_PROCEDURE' ||
                        eventOccurrence === '5_CLINIC_AFTER_PROCEDURE') && (
                        <FormControlLabel
                            value='PARTIALLY_VISIBLE'
                            control={<Radio/>}
                            label={t('cti_option_partially_visible', {productType: t(`pt_option_${productType.toLowerCase()}`)})}
                        />
                    )}

                {wasPatientInvolved === 'YES' &&
                    (eventOccurrence === '4_CLINIC_DURING_PROCEDURE' ||
                        eventOccurrence === '5_CLINIC_AFTER_PROCEDURE') && (
                        <FormControlLabel
                            value='OTHER_OUTCOME'
                            control={<Radio/>}
                            label={t('cti_option_other_outcome') as string}
                        />
                    )}

                {selectedOption === 'OTHER_OUTCOME' && (
                    <FormControl sx={{pt: 0}}>
                        <FormLabel sx={{mb: 1}}>
                            {t('cti_please_explain')}:
                        </FormLabel>
                        <TextField
                            multiline
                            minRows={2}
                            maxRows={4}
                            sx={{maxWidth: '40rem', mb: 2}}
                            error={!!estheticExplanationError}
                            helperText={estheticExplanationError}
                            value={estheticExplanation}
                            // onChange={handleChangeEvent('estheticExplanation')}
                            onChange={handleChange}
                        />
                        <FormHelperText
                            // error={!!errors.wasProductPlaced}
                        >
                            {/* {errors.wasProductPlaced} */}
                        </FormHelperText>
                    </FormControl>
                )}
            </Stack>
        </>
    )
}

export default EstheticOptions
